import React from "react";
import { GroupParticipantPropTypes } from "./types";
import { User as UserIcon } from "react-feather";
import Accordion from "../Accordion";
import useGroupOrder from "../../global/useGroupOrder";
import CartItem from "../CartItems/CartItem";
import i18next from "i18next";
import Decimal from "decimal.js";
import { formatPrice } from "../../Format";

const GroupParticipant = ({ participant, itemsCount }) => {
    const { groupOrderData } = useGroupOrder();

    const items =
        groupOrderData?.items.filter(
            (item) => item.owner_uid === participant.uid
        ) || [];

    if (items.length <= 0) {
        return null;
    }

    const priceTotal = ((items) => {
        let total = new Decimal(0);
        items.forEach((item) => {
            total = total.add(parseFloat(item.value_gross));
        });
        return formatPrice(total.toFixed(2));
    })(items);

    // TODO: This can be done differently (i18next) but is a smaller bug and will do the trick for now
    const transKey =
        items.length === 1 ? "productCount_one" : "productCount_other";

    return (
        <div className="group-participant__wrapper">
            <Accordion
                headerComponent={
                    <div className="group-participant">
                        <div className="group-participant__info">
                            <div className="group-participant__icon">
                                <UserIcon />
                            </div>
                            <div className="group-participant__user">
                                <p>{participant.name}</p>
                                <span>
                                    {i18next.t(`memberGroupOrder.${transKey}`, {
                                        count: itemsCount,
                                    })}
                                </span>
                            </div>
                        </div>
                        <span className="group-participant__price">
                            {priceTotal}
                        </span>
                    </div>
                }
            >
                {items.map((cartItem, index) => (
                    <CartItem
                        key={cartItem.product_id}
                        cartItem={cartItem}
                        inCartPosition={index}
                        items={groupOrderData?.items}
                        readOnly
                    />
                ))}
            </Accordion>
        </div>
    );
};

GroupParticipant.propTypes = GroupParticipantPropTypes;
export default GroupParticipant;
